import { render, staticRenderFns } from "./AdminCompanyDetails.vue?vue&type=template&id=66479a8c&scoped=true&"
import script from "./AdminCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66479a8c",
  null
  
)

export default component.exports